import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  DetailsWrapper,
  Divider,
  InfoText,
  LogoLoader,
  Modal,
  PageTitle,
  showToast,
} from "../../../../components";
import DocumentTable from "./PushDataToWorkforce/DocumentTable";
import EditEmployeeDetails from "./PushDataToWorkforce/Modal/EditEmployeeDetails";
import EditClientDetails from "./PushDataToWorkforce/Modal/EditClientDetails";
import EditPlacementDetails from "./PushDataToWorkforce/Modal/EditPlacementDetails";
import { pushToWorkforceApi, pushDataToWorkforceBackendApi, updateSubmissionStatus } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import { getAllUsers, getRaBdmLeadAndManagerApi } from "../../../../redux/slices/setting/settingApi";
import { dateFormator } from "../../../../utils";
import { updateCompanyDetails } from "../../../../redux/slices/accountDetails/accountDetailsAPi";

const InfoTextUse = ({ title, value }) => {
  return <InfoText size="sm" textWrap={true} title={title} value={value} />;
};

const AGREEMENT_NET_TERMS_MAP = {
  1: "30",
  2: "60",
  3: "90",
  4: "Split(50-50)",
  5: "Split(25-25-25-25)",
  6: "Split(3 Equal Parts)",
};

const WARRANTY_MAP = {
  1: "30 days",
  2: "60 days",
  3: "90 days",
  4: "120 days",
};
// const LOCAL_STORAGE_KEY = "pushDataWorkforce";

// // ////////////////////////
// function randomDate(start, end) {
//   const date = new Date(
//     start.getTime() + Math.random() * (end.getTime() - start.getTime()),
//   );
//   return date.toISOString().split("T")[0]; // YYYY-MM-DD
// }

// const docunentsData = Array.from({ length: 4 }, (_, i) => ({
//   id: i + 100,
//   documentType: [
//     "Direct Hire Agreemant",
//     "Offer Letter",
//     "Offer Confirmation Letter",
//   ][Math.floor(Math.random() * 3)],
//   uploadedOn: randomDate(new Date(2023, 0, 1), new Date()),
//   uploadedBy: [
//     "Aarav Sharma",
//     "Vivaan Kapoor",
//     "Aditya Verma",
//     "Yashraj Singh",
//     "Kunal Mehta",
//   ][Math.floor(Math.random() * 5)],
// }));



// let data = {
//   employee: {
//     firstName: "Harsh",
//     middleName: "Kumar",
//     lastName: "Sharma",
//     email: "harsh.sharma@example.com",
//     phone: {
//       countryCode: "+91",
//       number: "9876543210",
//     },
//     startDate: new Date().toISOString().split("T")[0],
//     placement: {
//       jobTitle: "Frontend Developer",
//       startDate: new Date().toISOString().split("T")[0],
//       offerSalary: "100000",
//       percentage: "100",
//       commissionValue: "1000",
//       warrantyPeriod: "12",
//       deliveryHeadName: "Astha Vaish",
//       deliverManagerName: "Vijaya Pendam",
//       bdm: "Krish Kapoor",
//       recruiter: "Sreejitha",
//       raManager: "Krish Pendam",
//       raLead: "",
//       ra: "",
//     },
//     address: {
//       addressLine1: "123 Main St, New York, NY 10001",
//       addressLine2: "",
//       city: "New York",
//       state: "NY",
//       zipCode: "10001",
//     },
//     documents: [...docunentsData],
//   },
//   client: {
//     name: "Zycus Systems LLC",
//     netTerms: "Net 30",
//     commissionType: "Fixed",
//     commission: "1000",
//     address: {
//       addressLine1: "123 Main St, New York, NY 10001",
//       addressLine2: "Apt 4B",
//       city: "New York",
//       state: "NY",
//       zipCode: "10001",
//     },
//     pocDetails: [
//       {
//         pocName: "Vikranth D.Reddy",
//         pocEmail: "vikranth46@gmail.com",
//         pocPhone: {
//           countryCode: "+91",
//           number: "8765432109",
//         },
//       },
//     ],
//     billingInvoice: [
//       {
//         name: "Revati V.Marva",
//         email: "revati.marva@example.com",
//         phone: {
//           countryCode: "+91",
//           number: "8975648457",
//         },
//       },
//     ],
//   },
// };

const defaultData = {
  employee: {
    firstName: "-",
    middleName: "-",
    lastName: "-",
    email: "-",
    alternateEmail: "-",
    phone: { countryCode: "-", number: "-" },
    gender: 1,
    dob: "-",
    classification: 1,
    employmentType: 1,
    empJobTitle: "-",

    placement: {
      jobTitle: "-",
      jobCode: "-",
      placementType: 1,
      commissionType: 1,
      billType: "-",
      startDate: "-",
      endDate: "-",
      offerSalary: "-",
      billRate: "-",
      payRate: "-",
      percentage: "-",
      targetAmount: "-",
      commissionValue: "-",
      warrantyPeriod: "-",
      deliveryHeadName: "-",
      deliverManagerName: "-",
      bdm: { name: "-", userId: 0, roleUiid: 0 },
      recruiter: { name: "-", userId: 0, roleUiid: 0 },
      raManager: { name: "-", userId: 0, roleUiid: 0 },
      raLead: { name: "-", userId: 0, roleUiid: 0 },
      ra: { name: "-", userId: 0, roleUiid: 0 },
    },

    address: {
      addressLine1: "-",
      addressLine2: "-",
      city: "-",
      state: "-",
      country: "United States",
      zipCode: "-",
    },

    documents: [],
  },

  client: {
    name: "-",
    website: "-",
    netTerms: "-",
    commissionType: "-",
    commission: "-",

    address: {
      addressLine1: "-",
      addressLine2: "-",
      city: "-",
      state: "-",
      country: "United States",
      zipCode: "-",
    },

    pocDetails: [
      {
        pocName: "-",
        pocEmail: "-",
        pocPhone: {
          countryCode: "-",
          number: "-",
        },
      },
    ],
    billingInvoice: [
      {
        name: "-",
        email: "-",
        phone: {
          countryCode: "",
          number: "-",
        },
      }
    ],
  },
};

const PushDataToWorkforce = () => {
  const [usersMap, setUsersMap] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const submissionId = location?.state?.submissionId || null;
  const storageKey = submissionId ? `ptw_draft_${submissionId}` : null;

  // Local helper for safe numeric display in info text
  const parseNum = (val) => {
    if (val === "-" || val === "" || val === null || val === undefined) return 0;
    if (typeof val === "number") return val;
    const cleaned = String(val).replace(/[$,]/g, "");
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  };

  // Returns empty string for dash/null placeholders so they aren't sent to the API
  const clean = (val) => {
    if (val === null || val === undefined || val === "-") return "";
    return String(val).trim();
  };

  const formatDisplayDate = (value) => {
    if (!value || value === "-" || value === "Invalid Date") return "-";
    if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) return value;
    return dateFormator(value, "date-month-year");
  };

  const formatValue = (val, type = "currency") => {
    if (val === undefined || val === null || val === "" || val === "-") return "-";
    const num = typeof val === "number" ? val : parseNum(val);
    if (isNaN(num)) return "-";
    if (type === "percentage") return `${num}%`;
    return `$${num.toLocaleString()}`;
  };

  // Safely extract display text from values that might be {label, value} objects
  const safeDisplay = (val) => {
    if (val === null || val === undefined) return "-";
    if (typeof val === "object" && !React.isValidElement(val)) {
      return val.label || val.value || val.name || "-";
    }
    return val;
  };

  const [mappedData, setMappedData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [showClientModal, setShowClientModal] = useState(false);
  const [showPlacementModal, setShowPlacementModal] = useState(false);
  const [documentsData, setDocumentsData] = useState()

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [emptyFieldsList, setEmptyFieldsList] = useState([]);

  const extractString = (val) => val?.label ?? val?.value ?? val ?? "-";

  const handleSaveEmployee = (formData) => {
    console.log("Saving Employee Details:", formData);
    setMappedData((prev) => {
      const currentData = prev || defaultData;
      const updated = {
        ...currentData,
        employee: {
          ...currentData.employee,
          firstName: formData.firstName,
          middleName: formData.middleName,
          lastName: formData.lastName,
          email: formData.email,
          alternateEmail: formData.alternateEmail,
          gender: formData.gender,
          dob: dateFormator(formData.dob, "date-month-year"),
          classification: formData.classification,
          employmentType: formData.employmentType,
          phone: {
            countryCode: formData.phoneNumber.code,
            number: formData.phoneNumber.number,
          },
          empJobTitle: formData.jobTitle,
          startDate: dateFormator(formData.startDate, "date-month-year"),
          placement: {
            ...(currentData.employee?.placement || defaultData.employee.placement),
            jobTitle: formData.jobTitle,
            startDate: dateFormator(formData.startDate, "date-month-year"),
          },
          address: {
            ...(currentData.employee?.address || defaultData.employee.address),
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
            city: extractString(formData.city),
            state: extractString(formData.state),
            country: extractString(formData.country),
            zipCode: formData.zipCode,
          }
        }
      };
      console.log("New Mapped Data (Employee):", updated);
      return updated;
    });
    setShowEmployeeModal(false);
  };

  const handleSaveClient = (formData) => {
    console.log("Saving Client Details:", formData);
    setMappedData((prev) => {
      const currentData = prev || defaultData;
      const updated = {
        ...currentData,
        client: {
          ...currentData.client,
          name: formData.legalBusinessName,
          legalBusinessName: formData.legalBusinessName,
          website: formData.website,
          federalId: formData.federalId,
          email: formData.email,
          netTerms: formData.netTerms,
          address: {
            ...(currentData.client?.address || defaultData.client.address),
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
            city: extractString(formData.city),
            state: extractString(formData.state),
            country: extractString(formData.country),
            zipCode: formData.zipCode,
          },
          pocDetails: (formData.pocDetails || []).map(poc => ({
            name: poc.name,
            email: poc.email,
            phone: {
              countryCode: poc.phone?.countryCode || poc.phone?.code || "",
              number: poc.phone?.number || "",
            }
          })),
          billingInvoice: (formData.billingInvoice || []).map(bill => ({
            name: bill.name,
            email: bill.email,
            phone: {
              countryCode: bill.phone?.countryCode || bill.phone?.code || "",
              number: bill.phone?.number || "",
            }
          })),
        }
      };
      console.log("New Mapped Data (Client):", updated);
      return updated;
    });
    setShowClientModal(false);
  };

  const validateEmptyFields = () => {
    const dataToCheck = mappedData || defaultData;
    const empties = [];

    const isEmpty = (val) => val === undefined || val === null || val === "" || val === "-" || val === 0 || val === "0";
    const checkField = (label, value) => {
      if (isEmpty(value)) {
        empties.push(label);
      }
    };

    // Employee
    checkField("Employee - First Name", dataToCheck.employee.firstName);
    // checkField("Employee - Middle Name", dataToCheck.employee.middleName);
    checkField("Employee - Last Name", dataToCheck.employee.lastName);
    checkField("Employee - Email", dataToCheck.employee.email);
    // checkField("Employee - Alternate Email", dataToCheck.employee.alternateEmail);
    checkField("Employee - Phone Number", dataToCheck.employee.phone?.number);
    // checkField("Employee - Gender", dataToCheck.employee.gender);
    // checkField("Employee - DOB", dataToCheck.employee.dob);
    checkField("Employee - Classification", dataToCheck.employee.classification);
    checkField("Employee - Employment Type", dataToCheck.employee.employmentType);
    checkField("Employee - Job Title", dataToCheck.employee.empJobTitle);
    checkField("Employee - Start Date", dataToCheck.employee.placement?.startDate);
    checkField("Employee - Address Line 1", dataToCheck.employee.address?.addressLine1);
    // checkField("Employee - Address Line 2", dataToCheck.employee.address?.addressLine2);
    checkField("Employee - City", dataToCheck.employee.address?.city);
    checkField("Employee - State", dataToCheck.employee.address?.state);
    checkField("Employee - Country", dataToCheck.employee.address?.country);
    // checkField("Employee - ZipCode", dataToCheck.employee.address?.zipCode);

    // Client
    checkField("Client - Legal Business Name", dataToCheck.client.name || dataToCheck.client.legalBusinessName);
    checkField("Client - Federal ID", dataToCheck.client.federalId);
    checkField("Client - Net Terms", dataToCheck.client.netTerms);
    checkField("Client - Website", dataToCheck.client.website);
    checkField("Client - Address Line 1", dataToCheck.client.address?.addressLine1);
    // checkField("Client - Address Line 2", dataToCheck.client.address?.addressLine2);
    checkField("Client - City", dataToCheck.client.address?.city);
    checkField("Client - State", dataToCheck.client.address?.state);
    checkField("Client - Country", dataToCheck.client.address?.country);
    // checkField("Client - ZipCode", dataToCheck.client.address?.zipCode);

    // POC Details
    const poc = dataToCheck.client.pocDetails?.[0];
    if (poc) {
      checkField("Client - POC Name", poc.name);
      checkField("Client - POC Email", poc.email);
      checkField("Client - POC Phone", poc.phone?.number);
    } else {
      empties.push("Client - POC Details");
    }

    // Billing Details
    const bill = dataToCheck.client.billingInvoice?.[0];
    if (bill) {
      checkField("Client - Billing Name", bill.name);
      checkField("Client - Billing Email", bill.email);
      checkField("Client - Billing Phone", bill.phone?.number);
    } else {
      empties.push("Client - Billing Details");
    }

    // Placement
    checkField("Placement - Job Title", dataToCheck.employee.placement?.jobTitle);
    checkField("Placement - Job Code", dataToCheck.employee.placement?.jobCode);
    checkField("Placement - Placement Type", dataToCheck.employee.placement?.placementType);
    checkField("Placement - Start Date", dataToCheck.employee.placement?.startDate);
    checkField("Placement - End Date", dataToCheck.employee.placement?.endDate);
    checkField("Placement - Bill Rate", dataToCheck.employee.placement?.billRate);
    checkField("Placement - Bill Type", dataToCheck.employee.placement?.billType);

    if (Number(dataToCheck.employee.placement?.placementType) !== 2) {
      checkField("Placement - Pay Rate", dataToCheck.employee.placement?.payRate);
    } else {
      checkField("Placement - Commission Type", dataToCheck.employee.placement?.commissionType);
      if (Number(dataToCheck.employee.placement?.commissionType) === 2) {
        checkField("Placement - Percentage", dataToCheck.employee.placement?.percentage);
      }
      checkField("Placement - Offered Salary", dataToCheck.employee.placement?.offerSalary);
    }

    checkField("Placement - Target Amount", dataToCheck.employee.placement?.targetAmount);
    checkField("Placement - Warranty Period", dataToCheck.employee.placement?.warrantyPeriod);

    // // Team
    // checkField("Team - Delivery Head Name", dataToCheck.employee.placement?.deliveryHeadName);
    // checkField("Team - Deliver Manager", dataToCheck.employee.placement?.deliverManager);
    // checkField("Team - BDM", dataToCheck.employee.placement?.bdm?.name);
    // checkField("Team - Recruiter", dataToCheck.employee.placement?.recruiter?.name);
    // checkField("Team - RA Manager", dataToCheck.employee.placement?.raManager?.name);
    // checkField("Team - RA Lead", dataToCheck.employee.placement?.raLead?.name);
    // checkField("Team - RA", dataToCheck.employee.placement?.ra?.name);

    return empties;
  };

  const onPushClick = () => {
    const empties = validateEmptyFields();
    if (empties.length > 0) {
      setEmptyFieldsList(empties);
      setShowWarningModal(true);
    } else {
      handlePushToWorkforce();
    }
  };

  const handlePushToWorkforce = async () => {
    const data = mappedData || defaultData;

    const payload = {
      atsSubmissionId: submissionId,
      uiid: submissionId,
      employee: {
        firstName: clean(data.employee.firstName),
        middleName: clean(data.employee.middleName),
        lastName: clean(data.employee.lastName),
        jobTitle: clean(data.employee.empJobTitle),
        emailAddress: clean(data.employee.email),
        alternateEmailAddress: clean(data.employee.alternateEmail),
        contactNumber: clean(data.employee.phone?.number),
        countryCode: clean(data.employee.phone?.countryCode) || "+1",
        gender: data.employee.gender,
        dob: clean(data.employee.dob),
        classification: data.employee.classification,
        employmentType: data.employee.employmentType,
        address: {
          line1: clean(data.employee.address.addressLine1),
          line2: clean(data.employee.address.addressLine2),
          city: clean(data.employee.address.city),
          state: clean(data.employee.address.state),
          country: clean(data.employee.address.country) || "United States",
          zipCode: clean(data.employee.address.zipCode),
        },
        startDate: clean(data.employee.placement.startDate),
      },
      client: {
        legalBusinessName: clean(data.client.name),
        website: clean(data.client.website),
        address: {
          line1: clean(data.client.address.addressLine1),
          line2: clean(data.client.address.addressLine2),
          city: clean(data.client.address.city),
          state: clean(data.client.address.state),
          country: clean(data.client.address.country) || "United States",
          zipCode: clean(data.client.address.zipCode),
        },
        poc: {
          name: clean(data.client.pocDetails[0]?.name),
          email: clean(data.client.pocDetails[0]?.email),
          phone: `${clean(data.client.pocDetails[0]?.phone?.countryCode)}${clean(data.client.pocDetails[0]?.phone?.number)}`,
        },
        billingPOC: {
          name: clean(data.client.billingInvoice[0]?.name),
          email: clean(data.client.billingInvoice[0]?.email),
          phone: `${clean(data.client.billingInvoice[0]?.phone?.countryCode)}${clean(data.client.billingInvoice[0]?.phone?.number)}`,
        },
        id: 0,
        netTerms: clean(data.client.netTerms),
        email: clean(data.client.email),
        federalId: clean(data.client.federalId),
        contactNumber: clean(data.client.contactNumber),
        commissionType: Number(data.client.commissionType),
        commission: clean(data.client.commission),
      },
      placement: {
        jobTitle: clean(data.employee.placement.jobTitle),
        jobCode: clean(data.employee.placement.jobCode),
        jobDescription: "",
        placementType: Number(data.employee.placement.placementType),
        employmentType: Number(data.employee.placement.placementType),
        offeredSalary: parseFloat(String(data.employee.placement.offerSalary).replace(/[$,]/g, "")) || 0,
        targetPercentage: parseFloat(String(data.employee.placement.percentage).replace(/[%,]/g, "")) || 0,
        targetAmount: parseFloat(String(data.employee.placement.targetAmount).replace(/[$,]/g, "")) || 0,
        warrantyPeriod: clean(data.employee.placement.warrantyPeriod),
        startDate: clean(data.employee.placement.startDate),
        endDate: clean(data.employee.placement.endDate),
        billRate: parseFloat(String(data.employee.placement.billRate).replace(/[$,]/g, "")) || 0,
        payRate: parseFloat(String(data.employee.placement.payRate).replace(/[$,]/g, "")) || 0,
        commissionType: Number(data.employee.placement.commissionType),
        billType: Number(data.employee.placement.billType) || undefined,
      },
      team: [
        { name: data.employee.placement.bdm.name, userId: data.employee.placement.bdm.userId, roleUiid: data.employee.placement.bdm.roleUiid, role: "BDM" },
        { name: data.employee.placement.recruiter.name, userId: data.employee.placement.recruiter.userId, roleUiid: data.employee.placement.recruiter.roleUiid, role: "RE" },
        { name: data.employee.placement.ra.name, userId: data.employee.placement.ra.userId, roleUiid: data.employee.placement.ra.roleUiid, role: "RA" },
        { name: data.employee.placement.raLead.name, userId: data.employee.placement.raLead.userId, roleUiid: data.employee.placement.raLead.roleUiid, role: "RA Lead" },
        { name: data.employee.placement.raManager.name, userId: data.employee.placement.raManager.userId, roleUiid: data.employee.placement.raManager.roleUiid, role: "RA Manager" },
      ].filter(t => t.name && t.name !== "-"),
      documents: (data.employee.documents || []).map(doc => ({
        name: doc.name,
        url: doc.url,
        key: doc.key,
        uploadedBy: doc.uploadedBy,
        documentType: doc.documentType,
        uploadedOn: doc.uploadedOn
      })),
      module: data.employee.placement.placementType === 1 ? "IT" : "NonIT",
    };

    console.log("Final PTW Payload:", payload);
    console.log("docs data", documentsData);

    /*
    const documentsArray = documentsData || [];
    const offerLetterDocUiids = [];
    const companyDocUiids = [];

    // Create documents in the Document collection first
    for (const doc of documentsArray) {
      if (!doc.key) continue;

      const isOffer = doc.documentType === "Offer Letter";
      const entityName = isOffer ? "candidates" : "companies";
      const targetId = isOffer ? candidateId : companyUiid;
      const targetPath = isOffer ? "candidates.documentIds" : "companies.documentIds";

      const docPayload = {
        docType: doc.documentType,
        ref: {
          id: targetId,
          entity: entityName,
          path: targetPath,
        },
        files: [
          {
            name: doc.name,
            key: doc.key,
            documentId: 1,
            addedBy: doc.uploadedBy?.userId || doc.uploadedBy || 1,
            addedOn: new Date(),
          },
        ],
        addedBy: doc.uploadedBy?.userId || doc.uploadedBy || 1,
      };

      try {
        const responseDoc = await axiosRequest({
          method: "POST",
          url: ENDPOINTS.ATS_UNIVERSAL.DOCUMENT_ADD,
          data: {
            coll: "Document",
            payload: docPayload,
          },
        });

        const newId = responseDoc?.data?.data?.[0]?.uiid || responseDoc?.data?.data?.uiid;
        if (newId) {
          if (isOffer) {
            offerLetterDocUiids.push(newId);
          } else {
            companyDocUiids.push(newId);
          }
        }
      } catch (err) {
        console.error("Failed to add document metadata:", doc, err);
      }
    }

    if (!companyUiid) {
      showToast("Company UIID missing!", "error");
      return;
    }

    if (companyDocUiids.length > 0) {
      const atsPayload = [
        {
          type: "PUSH",
          value: {
            documentIds: { $each: companyDocUiids },
          },
        },
      ];

      const responseAts = await updateCompanyDetails({
        coll: "Company",
        uiid: companyUiid,
        payload: atsPayload,
      });
      console.log("updated company response", responseAts);
    }

    if (candidateId && offerLetterDocUiids.length > 0) {
      const candidatePayload = [
        {
          type: "PUSH",
          value: {
            documentIds: { $each: offerLetterDocUiids },
          },
        },
      ];

      const responseCandidate = await axiosRequest({
        method: "PATCH",
        url: `${ENDPOINTS.CANDIDATES.UPDATE}?coll=Candidate&uiid=${candidateId}`,
        data: {
          payload: candidatePayload,
        },
      });
      console.log("updated candidate response", responseCandidate);
    }


    try {
      const response = await pushToWorkforceApi(payload);
      if (response?.success) {
        try {
          await updateSubmissionStatus({
            coll: "Submission",
            uiid: submissionId,
            payload: [
              {
                type: "SET",
                value: {
                  isPushedToWorkforce: true,
                }
              }
            ]
          });
        } catch (err) {
          console.error("Failed to update submission isPushedToWorkforce status", err);
        }

        showToast("Data pushed successfully!");
        navigate(-1);
      } else {
        showToast("Failed to push data: " + (response?.error || response?.msg || "Unknown error"), "error");
      }
    } catch (error) {
      console.error("Error pushing data:", error);
      alert("An error occurred while pushing data.");
    }
    */
    const requestData = {
      coll: "Submission",
      payload,
      documentsData: documentsData || [],
      companyUiid,
      candidateId,
      submissionId,
    };

    try {
      const response = await pushDataToWorkforceBackendApi(requestData);
      if (response?.success) {
        showToast("Data pushed successfully!");
        navigate(-1);
      } else {
        showToast("Failed to push data: " + (response?.error || response?.msg || "Unknown error"), "error");
      }
    } catch (error) {
      console.error("Error pushing data:", error);
      alert("An error occurred while pushing data.");
    }
  };

  const handleSavePlacement = (formData) => {
    console.log("Saving Placement Details:", formData);
    setMappedData((prev) => {
      const currentData = prev || defaultData;
      let updatedPlacement = {
        ...(currentData.employee?.placement || defaultData.employee.placement),
        jobTitle: formData.jobTitle,
        jobCode: formData.jobCode,
        placementType: formData.placementType,
        commissionType: formData.commissionType,
        billType: formData.billType,
        startDate: dateFormator(formData.startDate, "date-month-year"),
        endDate: dateFormator(formData.endDate, "date-month-year"),
        billRate: formData.billRate,
        payRate: formData.payRate,
        offerSalary: formData.offerSalary,
        percentage: formData.percentage,
        targetAmount: formData.targetAmount,
        warrantyPeriod: formData.warrantyPeriod,
      };

      // Auto-calculation logic
      const isPermanent = Number(updatedPlacement.placementType) === 2;
      const bill = Number(updatedPlacement.billRate) || 0;
      const targetPct = Number(updatedPlacement.percentage) || 0;
      const targetAmt = Number(updatedPlacement.targetAmount) || 0;

      if (!isPermanent) {
        const pay = Number(updatedPlacement.payRate) || 0;
        updatedPlacement.offerSalary = pay;
        updatedPlacement.targetAmount = bill - pay;
        updatedPlacement.percentage = bill > 0 ? Math.round(((bill - pay) / bill) * 100 * 100) / 100 : 0;
      } else {
        // Permanent (Non-IT) Logic: Ensure Bill Rate and Offered Salary match what was entered
        const base = Number(updatedPlacement.offerSalary || updatedPlacement.billRate) || 0;
        updatedPlacement.offerSalary = base;
        updatedPlacement.billRate = base;

        if (Number(updatedPlacement.commissionType) === 1) {
          // Flat
          updatedPlacement.percentage = base > 0 ? Math.round((targetAmt / base) * 100 * 100) / 100 : 0;
        } else {
          // Percentage
          updatedPlacement.targetAmount = Math.round(base * (targetPct / 100));
        }
      }

      const updated = {
        ...currentData,
        employee: {
          ...currentData.employee,
          placement: updatedPlacement
        }
      };
      console.log("New Mapped Data (Placement):", updated);
      return updated;
    });
    setShowPlacementModal(false);
  };

  useEffect(() => {
    checkApi()
  }, [submissionId])

  // Persist mappedData to localStorage whenever it changes (disabled)
  // useEffect(() => {
  //   if (storageKey && mappedData) {
  //     localStorage.setItem(storageKey, JSON.stringify(mappedData));
  //   }
  // }, [mappedData, storageKey]);


  const [companyUiid, setCompanyUiid] = useState(null);
  const [candidateId, setCandidateId] = useState(null)
  console.log("comap", companyUiid)

  async function checkApi() {
    setLoading(true);
    try {
      const response = await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.SUBMISSOINS.GET_ALL}`,
        params: {
          coll: "Submission",
          fil: JSON.stringify({ uiid: { type: "PUSH_DATA_TO_WORKFORCE", value: submissionId } }),
          useAggregate: true,
        }
      });

      const apiData = response?.data?.data?.[0];
      if (!apiData) return;
      const companyId = apiData?.company?.uiid || apiData?.job?.companyId;
      const candidateuploadId = apiData?.candidate?.uiid
      setCandidateId(candidateuploadId)
      console.log("apidata", apiData)
      setCompanyUiid(companyId); //  store uiid

      const job = apiData?.job || {};
      const jobPost = apiData?.jobPost || {};
      const recId = apiData?.addedBy;

      const initialIds = [job?.addedBy, jobPost?.addedBy, recId].filter(Boolean);
      let usersObj = {};
      let raLeadId = null;
      let raManagerId = null;

      if (initialIds.length) {
        const usersRes = await getAllUsers({
          coll: "User",
          fil: { uiid: { type: "NONE", value: initialIds } },
        });

        const users = usersRes?.data?.data || [];
        users.forEach((user) => {
          usersObj[user.uiid] = {
            name: `${user.firstName} ${user.lastName}`,
            userId: user.uiid,
            roleUiid: user.role,
            level: user.level
          };
        });

        // Resolve RA hierarchy and BDM hierarchy from backend
        const hierarchyUserIds = [job?.addedBy, jobPost?.addedBy].filter(Boolean);
        if (hierarchyUserIds.length > 0) {
          try {
            const raHierarchyRes = await getRaBdmLeadAndManagerApi({
              fil: JSON.stringify({
                uiid: {
                  type: "GET_TOP_RA_HIERARCHY_USER",
                  value: { userIds: hierarchyUserIds, roleTypes: [2, 3] }
                }
              }),
            });

            const hierarchyData = raHierarchyRes?.data?.data?.[0] || {};
            console.log("RA/BDM Hierarchy data:", hierarchyData);

            const raLead = hierarchyData?.ra?.lead;
            const raManager = hierarchyData?.ra?.manager;
            const bdmManager = hierarchyData?.bdm?.manager;

            // Map RA Lead
            if (raLead) {
              usersObj[raLead.uiid] = {
                name: `${raLead.firstName} ${raLead.lastName}`,
                userId: raLead.uiid,
                roleUiid: raLead.role?.uiid || raLead.role
              };
            }

            // Map RA Manager
            if (raManager) {
              usersObj[raManager.uiid] = {
                name: `${raManager.firstName} ${raManager.lastName}`,
                userId: raManager.uiid,
                roleUiid: raManager.role?.uiid || raManager.role
              };
            }

            // Level-based RA mapping
            const raUser = users.find((u) => u.uiid === job?.addedBy);
            const raLevel = raUser?.level;

            if (raLevel === 4) {
              // RA is a Lead: RA and RA Lead are the same person
              raLeadId = job?.addedBy;
              raManagerId = raManager?.uiid || null;
            } else if (raLevel === 5) {
              // RA is a Manager: RA and RA Manager are the same person, no lead
              raManagerId = job?.addedBy;
              raLeadId = null; // fallback to "-"
            } else {
              // Default: use hierarchy values
              raLeadId = raLead?.uiid || null;
              raManagerId = raManager?.uiid || null;
            }

            // Level-based BDM mapping
            const bdmUser = users.find((u) => u.uiid === jobPost?.addedBy);
            const bdmLevel = bdmUser?.level;

            if (bdmLevel === 5) {
              // BDM is a Manager: BDM name fills delivery head and delivery manager
              const bdmName = usersObj[jobPost?.addedBy]?.name || "-";
              usersObj._deliveryHeadName = bdmName;
            } else {
              // Default: use bdm.manager from hierarchy
              if (bdmManager) {
                usersObj[bdmManager.uiid] = {
                  name: `${bdmManager.firstName} ${bdmManager.lastName}`,
                  userId: bdmManager.uiid,
                  roleUiid: bdmManager.role?.uiid || bdmManager.role
                };
                usersObj._deliveryHeadName = `${bdmManager.firstName} ${bdmManager.lastName}`;
              }
            }
          } catch (error) {
            console.error("Failed to fetch RA hierarchy", error);
          }
        }
      }

      setUsersMap(usersObj);

      // Only set mapped data from API if it's currently null.
      // This prevents API responses from overwriting user edits/drafts if they arrive late.
      setMappedData((prev) => {
        if (prev) return prev;
        return mapApiToComponent(apiData, usersObj, { raLeadId, raManagerId });
      });
    } finally {
      setLoading(false);
    }
  }

  function mapApiToComponent(api, usersMap = {}, hierarchy = {}) {
    const { raLeadId, raManagerId } = hierarchy;
    const candidate = api?.candidate || {};
    const company = api?.company || {};
    const job = api?.job || {};
    const prospect = api?.prospect?.[0] || {};
    const jobPost = api?.jobPost || {}

    const defaultUser = { name: "-", userId: 0, roleUiid: 0 };

    return {
      employee: {
        firstName: candidate?.firstName || "-",
        middleName: candidate?.middleName || "-",
        lastName: candidate?.lastName || "-",
        gender: candidate?.gender || 1,
        dob: formatDisplayDate(candidate?.dob),
        classification: candidate?.classification || 1, // Defaulting to Billable
        employmentType: candidate?.employmentType || (job?.type === 'Contract' ? 1 : (job?.type === 'Permanent' ? 2 : 1)),
        email: candidate?.email?.primary?.email || "-",
        alternateEmail: candidate?.email?.secondary?.email || "-",

        phone: {
          countryCode: candidate?.mobile?.primary?.countryCode || "+1",
          number: candidate?.mobile?.primary?.number || "-",
        },
        empJobTitle: candidate?.jobTitle || job?.title || "-",

        placement: (() => {
          const payments = jobPost?.jobInfo?.payments || {};
          const billRate = payments.billRate?.amount || "-";
          const payRate = payments.payRate?.amount?.max || payments.payRate?.amount?.min || "-";
          const targetPercentage = api?.targetPercentage || "-";
          // JobTypes enum: 1=Full Time (Permanent), 2=Contract, 3=Part Time
          // Full Time (1) → Permanent/NonIT (2), Contract (2) or Part Time (3) → Contract/IT (1)
          const jobTypeNum = Number(jobPost?.jobInfo?.type || 0);
          let placementType;
          if (api?.placementType) {
            placementType = api.placementType;
          } else if (jobTypeNum === 1) {
            placementType = 2; // Full Time → Permanent
          } else if (jobTypeNum === 2 || jobTypeNum === 3) {
            placementType = 1; // Contract / Part Time → Contract
          } else {
            // Fallback: if both billRate and payRate exist it's likely a contract
            placementType = (billRate !== "-" && payRate !== "-") ? 1 : 2;
          }
          const commissionType = api?.commissionType || 2; // Default to Percentage

          const billVal = parseNum(billRate);
          const payVal = parseNum(payRate);
          const pctVal = parseNum(targetPercentage);

          let finalOfferedSalary = candidate?.salaryInfo?.expect?.amount?.min || "-";
          let finalTargetAmount = api?.targetAmount || "-";
          let finalPercentage = targetPercentage;

          if (placementType === 1) {
            // Contract (IT) Logic
            if (billRate !== "-" && payRate !== "-") {
              finalOfferedSalary = payRate;
              finalTargetAmount = billVal - payVal;
              finalPercentage = billVal !== 0 ? Math.round(((billVal - payVal) / billVal) * 100 * 100) / 100 : 0;
            }
          } else if (placementType === 2 && billRate !== "-") {
            // Permanent (Non-IT) Logic (e.g., Full Time)
            finalOfferedSalary = billVal; // Bill Rate is exactly Offered Salary
            if (Number(commissionType) === 1) {
              // Flat
              finalTargetAmount = parseNum(api?.targetAmount);
            } else {
              // Percentage
              finalTargetAmount = Math.round(billVal * (pctVal / 100));
            }
          }

          return {
            jobTitle: job?.title || candidate?.jobTitle || "-",
            jobCode:  jobPost?.jobInfo?.jobCode || jobPost?.jobId || "-",
            placementType,
            commissionType,
            billType: jobPost?.jobInfo?.payments?.billRate?.freqType || jobPost?.jobInfo?.payments?.payRate?.freqType || "-",
            startDate: formatDisplayDate(job?.startDate || jobPost?.jobInfo?.jobDates?.start),
            endDate: formatDisplayDate(job?.endDate || jobPost?.jobInfo?.jobDates?.end),
            offerSalary: finalOfferedSalary,
            billRate: billRate !== "-" ? parseNum(billRate) : "-",
            payRate: payRate !== "-" ? parseNum(payRate) : "-",
            percentage: finalPercentage,
            targetAmount: finalTargetAmount,
            warrantyPeriod: jobPost?.jobInfo?.warranty || company?.warranty || "-",

            deliveryHeadName: usersMap._deliveryHeadName || "-",
            deliverManagerName: usersMap._deliveryHeadName || "-",

            bdm: usersMap[jobPost?.addedBy] || defaultUser,
            recruiter: usersMap[api?.addedBy] || defaultUser,
            raManager: usersMap[raManagerId] || defaultUser,
            raLead: usersMap[raLeadId] || defaultUser,
            ra: usersMap[job?.addedBy] || defaultUser,
          };
        })(),

        address: {
          addressLine1: [
            candidate?.location?.city,
            candidate?.location?.state,
            candidate?.location?.zipCode
          ].filter(Boolean).join(", ") || "-",
          addressLine2: "-",
          city: candidate?.location?.city || "-",
          state: candidate?.location?.state || "-",
          country: candidate?.location?.country || "United States",
          zipCode: candidate?.location?.zipCode || "-",
        },

        documents: (candidate?.documents || candidate?.resumes || []).map(doc => {
          const file = doc.files?.[0] || doc;
          return {
            id: doc.uiid || uuidv4(),
            documentType: doc.docType || (doc.files ? "Resume" : "Other"),
            uploadedOn: formatDisplayDate(file.addedOn || doc.createdAt),
            uploadedBy: file.addedBy || "-",
            key: file.key || file.path || "",
            url: file.url || "",
            name: file.name || "Document"
          };
        }),
      },

      client: {
        uiid: company?.uiid,
        legalBusinessName: company?.name || "-",
        name: company?.name || "-",
        website: company?.website || "-",
        email: company?.email || "-",
        federalId: company?.federalId || "-",
        netTerms: company?.agreementNetTerms || "-",
        commissionType: 1, // Defaulting to Flat
        commission: "-",
        address: {
          addressLine1: [company?.location?.city, company?.location?.state, company?.location?.zipCode]
            .filter(Boolean)
            .join(", ") || "-",
          addressLine2: "-",
          city: company?.location?.city || "-",
          state: company?.location?.state || "-",
          country: company?.location?.country || "United States",
          zipCode: company?.location?.zipCode || "-",
        },

        pocDetails: [
          {
            id: uuidv4(),
            name: (prospect?.firstName || prospect?.lastName) ? `${prospect?.firstName || ""} ${prospect?.lastName || ""}`.trim() : "-",
            email: prospect?.email?.email || "-",
            phone: {
              countryCode: prospect?.mobile?.code || "+1",
              number: prospect?.mobile?.number || "-",
            },
          },
        ],
        billingInvoice: [
          {
            id: uuidv4(),
            name: (prospect?.firstName || prospect?.lastName) ? `${prospect?.firstName || ""} ${prospect?.lastName || ""}`.trim() : "-",
            email: prospect?.email?.email || "-",
            phone: {
              countryCode: prospect?.mobile?.code || "+1",
              number: prospect?.mobile?.number || "-",
            },
          },
        ],
      },
    };
  }


  const data = mappedData || defaultData;

  if (loading) {
    return (
      <div className="w-full h-full flex-1 flex items-center justify-center">
        <LogoLoader />
      </div>
    );
  }

  return (
    <div className="w-full h-full flex-1 flex flex-col overflow-auto">
      <div className="flex items-center justify-between mb-1 mr-2">
        <div className="flex gap-1 items-center">
          <Button
            type="icon"
            variant="text"
            icon="west"
            color="black"
            onClick={() => navigate(-1)}
          />

          <PageTitle title="Details" tag="h6" />
        </div>

        <Button
          title="Push to WorkForce"
          icon="east"
          size="sm"
          iconPosition="after"
          variant="contained"
          color="primary"
          onClick={() => onPushClick()}
        />
      </div>
      <div className="w-full flex flex-col gap-6">
        <hr className="my-1 border-gray-200" />
        <DetailsWrapper
          title={"Employee Details"}
          onClick={() => setShowEmployeeModal(true)}
        >
          <div className="p-3 py-4 grid xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            <InfoTextUse title={"First Name"} value={data.employee.firstName} />
            <InfoTextUse title={"Middle Name"} value={data.employee.middleName} />
            <InfoTextUse title={"Last Name"} value={data.employee.lastName} />
            <InfoTextUse title={"Email"} value={data.employee.email} />
            <InfoTextUse title={"Alternate Email"} value={data.employee.alternateEmail} />
            <InfoTextUse
              title={"Phone"}
              value={
                <div className="text-sm">
                  {data?.employee?.phone?.countryCode} {data?.employee?.phone?.number || "-"}
                </div>
              }
            />
            <InfoTextUse
              title={"Gender"}
              value={
                { 1: "Male", 2: "Female", 3: "Wish not to specify", 4: "Other" }[data.employee.gender] || data.employee.gender
              }
            />
            <InfoTextUse title={"DOB"} value={formatDisplayDate(data.employee.dob)} />
            <InfoTextUse
              title={"Classification"}
              value={
                { 1: "Billable", 2: "Non-Billable" }[data.employee.classification] || data.employee.classification
              }
            />
            <InfoTextUse
              title={"Employment Type"}
              value={
                { 1: "Regular", 2: "Permanent", 3: "Contractor", 4: "Reference" }[data.employee.employmentType] || data.employee.employmentType
              }
            />
            <InfoTextUse
              title={"Job Title"}
              value={data.employee.empJobTitle}
            />
            <InfoTextUse
              title={"Start Date"}
              value={formatDisplayDate(data.employee.placement.startDate)}
            />
            <InfoTextUse
              title={"Address Line 1"}
              value={data.employee.address.addressLine1}
            />
            <InfoTextUse
              title={"Address Line 2"}
              value={data.employee.address.addressLine2}
            />
            <InfoTextUse title={"City"} value={safeDisplay(data.employee.address.city)} />
            <InfoTextUse title={"State"} value={safeDisplay(data.employee.address.state)} />
            <InfoTextUse title={"Country"} value={safeDisplay(data.employee.address.country)} />
            <InfoTextUse
              title={"ZipCode"}
              value={data.employee.address.zipCode}
            />
          </div>
        </DetailsWrapper>
        <DetailsWrapper
          title={"Client Details"}
          onClick={() => setShowClientModal(true)}
        >
          <div className="p-3 py-4 grid xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            <InfoTextUse
              title={"Legal Business Name"}
              value={data.client.legalBusinessName || data.client.name}
            />
            <InfoTextUse
              title={"Federal ID"}
              value={data.client.federalId}
            />
            <InfoTextUse
              title={"Net Terms"}
              value={AGREEMENT_NET_TERMS_MAP[data.client.netTerms] || safeDisplay(data.client.netTerms)}
            />
            <InfoTextUse
              title={"Website"}
              value={data.client.website}
            />
            <InfoTextUse
              title={"Address line 1"}
              value={data.client.address.addressLine1}
            />
            <InfoTextUse
              title={"Address line 2"}
              value={data.client.address.addressLine2}
            />
            <InfoTextUse title={"City"} value={safeDisplay(data.client.address.city)} />
            <InfoTextUse title={"State"} value={safeDisplay(data.client.address.state)} />
            <InfoTextUse title={"Country"} value={safeDisplay(data.client.address.country)} />
            <InfoTextUse
              title={"Zip Code"}
              value={data.client.address.zipCode}
            />

          </div>
          <div className="grid gap-5 xs:grid-cols-1 md:grid-cols-2 my-4">
            <DetailsWrapper title={"POC Details"}>
              <>
                {data.client.pocDetails.map((poc, index) => (
                  <div
                    className="p-3 py-4 grid xs:grid-cols-2 xl:grid-cols-3 gap-6"
                    key={index}
                  >
                    <InfoTextUse title={"POC Name"} value={poc?.name} />
                    <InfoTextUse title={"POC Email ID"} value={poc?.email} />
                    <InfoTextUse
                      title={"POC Phone number"}
                      value={
                        (poc?.phone?.countryCode ? poc.phone.countryCode + " " : "") + (poc?.phone?.number || "-")
                      }
                    />
                  </div>
                ))}
              </>
            </DetailsWrapper>
            <DetailsWrapper title={"Billing and Invoicing"}>
              <>
                {data.client.billingInvoice.map((bill, index) => (
                  <div
                    className="p-3 py-4 grid xs:grid-cols-2 xl:grid-cols-3 gap-6"
                    key={index}
                  >
                    <InfoTextUse title={"Name"} value={bill?.name} />
                    <InfoTextUse title={"Email ID"} value={bill?.email} />
                    <InfoTextUse
                      title={"Phone number"}
                      value={
                        (bill?.phone?.countryCode ? bill.phone.countryCode + " " : "") + (bill?.phone?.number || "-")
                      }
                    />
                  </div>
                ))}
              </>
            </DetailsWrapper>
          </div>
        </DetailsWrapper>
        <DetailsWrapper
          title={"Placement Details"}
          onClick={() => setShowPlacementModal(true)}
        >
          <div className="p-3 py-4 grid xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            <InfoTextUse
              title={"Job Title"}
              value={data.employee.placement.jobTitle}
            />
            <InfoTextUse
              title={"Job Code"}
              value={data.employee.placement.jobCode}
            />
            <InfoTextUse
              title={"Placement Type"}
              value={
                { 1: "Contract", 2: "Permanent" }[Number(data.employee.placement.placementType)] || data.employee.placement.placementType
              }
            />
            <InfoTextUse
              title={"Start Date"}
              value={formatDisplayDate(data.employee.placement.startDate)}
            />
            <InfoTextUse
              title={"End Date"}
              value={formatDisplayDate(data.employee.placement.endDate)}
            />
            <InfoTextUse
              title={"Bill Rate"}
              value={formatValue(data.employee.placement.billRate)}
            />
            <InfoTextUse
              title={"Bill Type"}
              value={
                { 1: "Hourly", 2: "Daily", 3: "Weekly", 4: "Monthly", 5: "Annual" }[Number(data.employee.placement.billType)] || safeDisplay(data.employee.placement.billType)
              }
            />

            {/* Conditional Fields based on Placement Type */}
            {Number(data.employee.placement.placementType) !== 2 && (
              <InfoTextUse
                title={"Pay Rate"}
                value={formatValue(data.employee.placement.payRate)}
              />
            )}

            {Number(data.employee.placement.placementType) === 2 && (
              <>
                <InfoTextUse
                  title={"Commission Type"}
                  value={
                    { 1: "Flat", 2: "Percentage" }[Number(data.employee.placement.commissionType)] || data.employee.placement.commissionType
                  }
                />

                {Number(data.employee.placement.commissionType) === 2 && (
                  <InfoTextUse
                    title={"Percentage"}
                    value={formatValue(data.employee.placement.percentage, "percentage")}
                  />
                )}

                <InfoTextUse
                  title={"Offered Salary"}
                  value={formatValue(data.employee.placement.offerSalary)}
                />
              </>
            )}

            <InfoTextUse
              title={"Target Amount"}
              value={formatValue(data.employee.placement.targetAmount)}
            />

            <InfoTextUse
              title={"Warranty Period"}
              value={WARRANTY_MAP[data.employee.placement.warrantyPeriod] || safeDisplay(data.employee.placement.warrantyPeriod)}
            />
          </div>
          <Divider />
          <div className="p-3 py-4 grid xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            <InfoTextUse
              title={"Delivery Head Name"}
              value={
                <div className="flex items-center gap-6  text-black   leading-tight  text-[14px] font-medium">
                  {data.employee.placement.deliveryHeadName}
                  {/* <span className="rounded-full px-3 py-1 bg-gray-200 text-[10px]">
                    24%
                  </span> */}
                </div>
              }
            />
            <InfoTextUse
              title={"Deliver Manager"}
              value={data.employee.placement.deliverManagerName}
            />
            <InfoTextUse title={"BDM"} value={data.employee.placement.bdm.name} />
            <InfoTextUse
              title={"Recruiter"}
              value={data.employee.placement.recruiter.name}
            />
          </div>
          <div className="p-3 py-4 grid xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            <InfoTextUse
              title={"RA Manager"}
              value={data.employee.placement.raManager.name}
            />
            <InfoTextUse
              title={"RA Lead"}
              value={data.employee.placement.raLead.name}
            />
            <InfoTextUse title={"RA"} value={data.employee.placement.ra.name} />
          </div>
        </DetailsWrapper>
        <DetailsWrapper title={"Document"}>
          <div className="flex-1 flex flex-col  overflow-hidden max-h-80">
            <DocumentTable
              data={data.employee.documents}
              candidateId={submissionId}
              usersMap={usersMap}
              onUpdate={(docs) => {
                console.log("Updating Documents:", docs);
                setDocumentsData(docs)
                setMappedData(prev => {
                  const currentData = prev || defaultData;
                  return {
                    ...currentData,
                    employee: {
                      ...currentData.employee,
                      documents: docs
                    }
                  };
                });
              }}
            />
          </div>
        </DetailsWrapper>
      </div>
      <Modal
        isOpen={showEmployeeModal}
        onClose={() => setShowEmployeeModal(false)}
        title="Edit Employee Details"
        width="max-w-[900px]"
      >
        <EditEmployeeDetails
          data={data}
          onClose={() => setShowEmployeeModal(false)}
          onSave={handleSaveEmployee}
        />
      </Modal>
      <Modal
        isOpen={showClientModal}
        onClose={() => setShowClientModal(false)}
        title="Edit Client Details"
        width="max-w-[1200px]"
      >
        <EditClientDetails
          data={data}
          onClose={() => setShowClientModal(false)}
          onSave={handleSaveClient}
        />
      </Modal>
      <Modal
        isOpen={showPlacementModal}
        onClose={() => setShowPlacementModal(false)}
        title="Edit Placement Details"
        width="max-w-[1200px]"
      >
        <EditPlacementDetails
          data={data}
          onClose={() => setShowPlacementModal(false)}
          onSave={handleSavePlacement}
        />
      </Modal>
      <Modal
        isOpen={showWarningModal}
        onClose={() => setShowWarningModal(false)}
        title="Missing Data Warning"
        width="max-w-[600px]"
      >
        <div className="p-5 flex flex-col gap-4">
          <p className="text-sm text-gray-700">The following fields are empty. Do you want to continue without entering data in these fields?</p>
          <ul className="list-disc pl-5 max-h-60 overflow-y-auto">
            {emptyFieldsList.map((field, idx) => (
              <li key={idx} className="text-sm text-red-500 font-medium mb-1">
                {field}
              </li>
            ))}
          </ul>
          <div className="flex gap-3 justify-end mt-4 border-t pt-4">
            <Button title="Cancel" variant="outlined" onClick={() => setShowWarningModal(false)} />
            <Button title="Continue" color="primary" onClick={() => {
              setShowWarningModal(false);
              handlePushToWorkforce();
            }} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PushDataToWorkforce;
